import React from 'react';
import Menu from '../../features/menu/Menu';

const HomePage = ({ ageValid, setAgeValid }) => {
  return <Menu ageValid={ageValid} setAgeValid={setAgeValid} />;
};

export default HomePage;
